@charset "UTF-8";

/* src/app/components/v2-add-multiple-items/v2-add-multiple-items.component.scss */
:host {
  display: contents;
}
body.v2-add-multiple-items-open {
  overflow: hidden;
}
.v2-add-multiple-items {
  position: fixed;
  inset: 0;
  height: 100%;
  max-height: 100dvh;
  z-index: 10000;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  transform-origin: 50% 50%;
  animation: v2-add-multiple-items-enter 0.4s cubic-bezier(0.22, 1, 0.36, 1) both;
  background: var(--exme-overlay-atmosphere-background);
}
.v2-add-multiple-items.v2-add-multiple-items--closing {
  pointer-events: none;
  animation: v2-add-multiple-items-exit 0.4s cubic-bezier(0.22, 1, 0.36, 1) both;
}
@keyframes v2-add-multiple-items-enter {
  from {
    opacity: 0;
    transform: scale(0.96) translateY(10px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}
@keyframes v2-add-multiple-items-exit {
  from {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
  to {
    opacity: 0;
    transform: scale(0.96) translateY(8px);
  }
}
@media (prefers-reduced-motion: reduce) {
  .v2-add-multiple-items {
    animation: none;
  }
  .v2-add-multiple-items.v2-add-multiple-items--closing {
    animation: none;
    opacity: 0;
  }
}
.v2-am-ao-close {
  position: absolute;
  top: 0.65rem;
  right: calc(0.65rem + env(safe-area-inset-right));
  z-index: 60;
  width: 44px;
  height: 44px;
  margin: 0;
  padding: 0;
  border: none;
  border-radius: 50%;
  font-size: 1.5rem;
  line-height: 1;
  cursor: pointer;
  font-family: inherit;
  color: rgba(13, 18, 24, 0.9);
  background: rgba(255, 255, 255, 0.88);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  transform: scale(1);
  transition: transform 0.12s ease, background 0.12s ease;
}
body.dark .v2-am-ao-close {
  color: rgba(255, 255, 255, 0.92);
  background: rgba(22, 28, 36, 0.92);
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.3);
}
.v2-am-ao-close:active {
  transform: scale(0.88);
}
body.dark .v2-am-ao-close:active {
  background: rgba(32, 40, 52, 0.96);
}
body:not(.dark) .v2-am-ao-close:active {
  background: rgba(255, 255, 255, 0.96);
}
.v2-am-ao-close:focus-visible {
  outline: 2px solid rgba(13, 18, 24, 0.45);
  outline-offset: 2px;
}
body.dark .v2-am-ao-close:focus-visible {
  outline: 2px solid rgba(255, 255, 255, 0.7);
}
.v2-am-ao-title-pill {
  position: absolute;
  top: 1.1rem;
  left: 50%;
  transform: translateX(-50%);
  z-index: 55;
  width: max-content;
  max-width: min(92vw, 22rem);
  padding: 0.42rem 0.95rem;
  text-align: center;
  font-size: 0.8rem;
  font-weight: 600;
  letter-spacing: 0.02em;
  line-height: 1.35;
  color: rgba(13, 18, 24, 0.92);
  pointer-events: none;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.7);
  border: 1px solid rgba(13, 18, 24, 0.08);
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
}
body.dark .v2-am-ao-title-pill {
  color: rgba(255, 255, 255, 0.94);
  background: rgba(22, 28, 36, 0.9);
  border-color: rgba(255, 255, 255, 0.12);
  box-shadow: 0 2px 14px rgba(0, 0, 0, 0.35);
}
.v2-am-floating-progress {
  position: fixed;
  top: 3.35rem;
  left: 50%;
  transform: translateX(-50%);
  width: min(220px, 70vw);
  z-index: 62;
  pointer-events: none;
}
.v2-add-multiple-items-main {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}
.v2-am-progress-native {
  width: 100%;
  max-width: 220px;
  height: 4px;
  border-radius: 4px;
  overflow: hidden;
  background: rgba(0, 0, 0, 0.08);
}
body.dark .v2-am-progress-native {
  background: rgba(255, 255, 255, 0.12);
}
.v2-am-progress-native__bar {
  height: 100%;
  width: 42%;
  border-radius: 4px;
  background: var(--ion-color-primary);
  animation: v2-am-progress-slide 1.1s ease-in-out infinite;
}
@keyframes v2-am-progress-slide {
  0% {
    transform: translateX(-120%);
  }
  100% {
    transform: translateX(320%);
  }
}
@media (prefers-reduced-motion: reduce) {
  .v2-am-progress-native__bar {
    animation: none;
    width: 100%;
    opacity: 0.7;
  }
}
.manage-content {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  background: transparent;
}
.v2-add-multiple-items-scroll {
  -webkit-overflow-scrolling: touch;
  padding-left: env(safe-area-inset-left);
  padding-right: env(safe-area-inset-right);
  padding-top: 3.5rem;
}
.v2-am-wrap.manage-wrapper {
  padding-bottom: calc(1rem + env(safe-area-inset-bottom));
}
.manage-wrapper {
  padding: clamp(1rem, 4vw, 1.4rem) clamp(1rem, 4vw, 1.25rem);
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  max-width: 520px;
  margin-inline: auto;
  width: 100%;
}
.manage-wrapper > * {
  opacity: 0;
  transform: scale(0.9) translateY(-40px);
  transition: opacity 0.5s ease, transform 0.5s ease;
}
.manage-wrapper.opened.loaded > * {
  opacity: 1;
  transform: scale(1) translateY(0);
  transition-delay: 0.2s;
}
@media (prefers-reduced-motion: reduce) {
  .manage-wrapper > * {
    opacity: 1;
    transform: none;
    transition: opacity 0.2s ease;
  }
  .manage-wrapper.opened.loaded > * {
    transition-delay: 0s !important;
  }
}
.v2-ami-footer {
  flex-shrink: 0;
  padding: 0.65rem clamp(1rem, 4vw, 1.25rem);
  padding-bottom: calc(0.65rem + env(safe-area-inset-bottom));
  background: transparent;
  border: none;
  box-shadow: none;
}
body.dark .v2-ami-footer {
  background: transparent;
  border: none;
  box-shadow: none;
}
.v2-ami-footer-save-host {
  display: block;
  width: 100%;
  max-width: 520px;
  margin-inline: auto;
}
.v2-ami-footer-save-host .btn-wrapper {
  width: 100%;
}
.v2-ami {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
}
.v2-ami-panel {
  background: rgba(255, 255, 255, 0.7);
  border: 1px solid rgba(13, 18, 24, 0.07);
  border-radius: 18px;
  padding: clamp(1rem, 4vw, 1.35rem);
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
}
.v2-ami-panel--intro {
  padding: clamp(0.9rem, 3vw, 1.15rem) clamp(1rem, 4vw, 1.35rem);
}
.v2-ami-panel--intro .v2-ami-lead {
  font-size: 0.88rem;
}
.v2-ami-lead {
  margin: 0;
  font-size: 0.9rem;
  line-height: 1.5;
  font-weight: 500;
  color: var(--ion-color-text);
  opacity: 0.92;
}
.v2-ami-section-label {
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--ion-color-text);
  opacity: 0.85;
}
.v2-ami-textarea-wrap {
  border-radius: 14px;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.96);
  border: 1px solid rgba(13, 18, 24, 0.1);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
}
.v2-ami-textarea {
  display: block;
  width: 100%;
  box-sizing: border-box;
  margin: 0;
  padding: 0.65rem 0.85rem;
  font: inherit;
  font-size: 0.95rem;
  line-height: 1.45;
  min-height: 7rem;
  resize: vertical;
  border: none;
  background: transparent;
  color: var(--ion-color-text);
}
.v2-ami-textarea:focus {
  outline: none;
}
.v2-ami-textarea::placeholder {
  color: var(--ion-color-medium);
  opacity: 0.85;
}
.v2-ami-btn-wrap {
  width: 100%;
  margin-top: 0.15rem;
}
.v2-ami-add-btn {
  display: block;
  width: 100%;
}
.v2-ami-add-btn .btn-wrapper {
  width: 100%;
}
.v2-ami-metrics {
  display: flex;
  flex-wrap: wrap;
  gap: 0.65rem;
}
.v2-ami-metric {
  flex: 1 1 calc(50% - 0.35rem);
  min-width: 140px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.25rem;
  padding: 0.55rem 0.75rem;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.7);
  border: 1px solid rgba(13, 18, 24, 0.07);
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
}
.v2-ami-metric-label {
  font-size: 0.65rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  line-height: 1.2;
  color: var(--ion-color-text);
  opacity: 0.88;
}
.v2-ami-metric-value {
  font-size: 1.25rem;
  font-weight: 800;
  font-variant-numeric: tabular-nums;
  line-height: 1;
  color: var(--ion-color-primary);
}
.v2-ami-list {
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
}
.v2-ami-item-card {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 0.65rem;
  padding: 0.75rem 0.85rem;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.7);
  border: 1px solid rgba(13, 18, 24, 0.07);
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
}
.v2-ami-item-body {
  flex: 1;
  min-width: 0;
}
.v2-ami-item-title-row {
  display: flex;
  flex-direction: row;
  align-items: baseline;
  gap: 0.5rem;
  flex-wrap: wrap;
  margin-bottom: 0.35rem;
}
.v2-ami-item-id {
  margin: 0;
  flex-shrink: 0;
  font-size: 0.72rem;
  font-weight: 800;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--ion-color-primary);
  font-variant-numeric: tabular-nums;
}
.v2-ami-item-name {
  margin: 0;
  flex: 1 1 12rem;
  min-width: 0;
  font-size: 0.95rem;
  font-weight: 600;
  line-height: 1.35;
  color: var(--ion-color-text);
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  overflow: hidden;
}
.v2-ami-item-meta {
  margin: 0 0 0.2rem;
  font-size: 0.78rem;
  font-weight: 600;
  line-height: 1.35;
}
.v2-ami-item-meta--warn {
  color: var(--ion-color-warning, #ffc221);
}
.v2-ami-item-meta--new {
  color: var(--ion-color-warning, #ffc221);
}
.v2-ami-item-qty {
  margin: 0;
  font-size: 0.82rem;
  font-weight: 600;
  color: var(--ion-color-text);
  opacity: 0.85;
}
.v2-ami-item-remove-btn {
  flex-shrink: 0;
  width: 44px;
  height: 44px;
  margin: -0.25rem -0.35rem -0.25rem 0;
}
.v2-ami-item-remove-btn .btn-wrapper {
  width: 100%;
  height: 100%;
}
.v2-ami-item-remove-btn .btn {
  min-height: 0;
  padding: 0.5rem;
  border-radius: 12px;
}
body.dark .v2-ami-panel,
body.dark .v2-ami-metric,
body.dark .v2-ami-item-card {
  background: rgba(22, 28, 36, 0.7);
  border-color: rgba(255, 255, 255, 0.08);
  box-shadow: 0 2px 14px rgba(0, 0, 0, 0.25);
}
body.dark .v2-ami-textarea-wrap {
  background: rgba(22, 28, 36, 0.7);
  border-color: rgba(255, 255, 255, 0.12);
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
}
/*# sourceMappingURL=v2-add-multiple-items.component.css.map */
